import React from 'react';

const CrosshairEffect = ({ onHole }) => (
  <div
    className="egg-crosshair"
    aria-label="Crosshair mode"
    onClick={(e) => {
      const rect = e.currentTarget.getBoundingClientRect();
      onHole({
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      });
    }}
  >
    <div className="egg-crosshair-hint">Наведи прицел и сделай дырку (Esc или клик вне — закрыть)</div>
  </div>
);

export default CrosshairEffect;

